import {Initialization} from "./initialization.js";
import {TrackHelper} from "./track_helper.js"
import initMoreCombosTracking from "./more_combos_tracking";
import initTopicPromoTracking from "./topic_promo_tracking";
import "../scss/all.scss";
import { onMount } from "@otto-ec/global-resources/dom";

window.o_global = window.o_global || {};

function initializeCombo(element) {
    window.o_combo = window.o_combo || {};
    window.o_combo.trackHelper = new TrackHelper();
    window.o_combo.initMoreCombosTracking = initMoreCombosTracking;
    window.o_combo.initTopicPromoTracking = initTopicPromoTracking;
    window.o_combo.init = new Initialization();
    window.o_combo.init.initialize([element]);
}

function initializeComboCinema(element) {
    window.o_combo = window.o_combo || {};
    window.o_combo.trackHelper = new TrackHelper();
    window.o_combo.init = new Initialization();
    window.o_combo.init.initialize([element], "cinema");
}

onMount(".combo_content", async (element) => {
    initializeCombo(element);
})

onMount(".cinema-combo", async (element) => {
    initializeComboCinema(element);
})

onMount("#more_combos", async () => {
    window.o_combo.initMoreCombosTracking(document);
    window.o_combo.initTopicPromoTracking(document);
})
